module.exports = __webpack_public_path__ + "img/4_ava.4de98b21.jpg";